module.exports = __webpack_public_path__ + "img/zy-jc-bj.48dd053a.png";